export interface SendingFinished {
  type: '@formCreator/EVENT_SEQ_SENDING_FINISHED';
}

export const sendingFinished = (): SendingFinished => ({
  type: '@formCreator/EVENT_SEQ_SENDING_FINISHED',
});
